<template>
  <div>
    <el-table ref="multipleTable" row-key="id" :data="tableData" tooltip-effect="light" :header-cell-style="{ backgroundColor: '#ffffff', color: '#000' }">
      <el-table-column label="业主姓名" align="center">
        <template slot-scope="scope">{{ scope.row.ownerName || '-' }}</template>
      </el-table-column>
      <el-table-column label="联系方式" align="center">
        <template slot-scope="scope">
          {{ scope.row.ownerPhone || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="费用属性" align="center">
        <template slot-scope="scope">{{ scope.row.itemAttributeStr || '-' }}</template>
      </el-table-column>
      <el-table-column label="欠费开始日期" align="center">
        <template slot-scope="scope">{{ cutTime(scope.row.billDate, ' ') }}</template>
      </el-table-column>
      <el-table-column label="欠费时长" align="center">
        <template slot-scope="scope">
          <span v-if="Number(scope.row.overdueDays) && Number(scope.row.overdueMouths)">{{ `${scope.row.overdueMouths}月${scope.row.overdueDays}天` }}</span>
          <span v-if="Number(scope.row.overdueMouths) && !Number(scope.row.overdueDays)">{{ scope.row.overdueMouths }}月</span>
          <span v-if="Number(scope.row.overdueDays) && !Number(scope.row.overdueMouths)">{{ scope.row.overdueDays }}天</span>
          <span v-if="!Number(scope.row.overdueDays) && !Number(scope.row.overdueMouths)">-</span>
        </template>
      </el-table-column>
      <el-table-column label="欠费金额" align="center">
        <template slot-scope="scope">
          {{ keepTwoDecimal(scope.row.orderAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" fixed="right" align="center" width="100">
        <template slot-scope="scope">
          <el-link type="primary" @click="preview(scope.row)">未缴明细</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pt-30"
      layout="total, prev, pager, next, jumper,sizes"
      background
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="[10, 50, 100]"
      :total="total"
      @size-change="currentChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
import { buildingRoomUnPayPage, buildingRoomUnPayCount } from '@/api/finance'

export default {
  inject: ['indexThis'],
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.orderCustomList()
    },
    async orderCustomList() {
      const { data: res } = await buildingRoomUnPayPage({
        buildingRoomId: this.indexThis.housesInfo.buildingRoomId,
        communityId: this.indexThis.housesInfo.communityId,
        ...this.page,
      })
      this.tableData = res || []
      const { data: total } = await buildingRoomUnPayCount({
        buildingRoomId: this.indexThis.housesInfo.buildingRoomId,
        communityId: this.indexThis.housesInfo.communityId,
      })
      this.total = Number(total)
    },

    // 获取详情
    preview(value) {
      this.indexThis.$refs.CardPayOrderDetail.queryData = {
        buildingRoomId: value.buildingRoomId,
        itemId: value.itemId,
        ownerName: value.ownerName,
        itemAttribute: value.itemAttribute,
      }
      this.indexThis.$refs.CardPayOrderDetail.unPayDetailPage()
      this.indexThis.$refs.CardPayOrderDetail.drawer = true
    },

    currentChange() {
      this.orderCustomList()
    },
  },
}
</script>
